export const test_data = {
  bp_bluetooth: {
    devid: "AD914E4998C2",
    model: "Zewa UAM-910BT",
    type: "Blood Pressure",
    hub_id: "hub_id",
    utc: 1660116799,
    bat: 0,
    tel: { sys: 129, dia: 77, pul: 68, ihb: false, map: 94, unum: 1 },
  },
  "pulse OX": {
    devid: "10082C5ECC08",
    model: "Zewa PulseOx",
    type: "pulse OX",
    hub_id: "hub_id",
    utc: 1660116854,
    bat: 0,
    tel: { spo2: 99, pul: 72, pi: 11.7 },
  },
  Scale: {
    devid: "6876271687DB",
    model: "Zewa 21300",
    type: "Scale",
    hub_id: "hub_id",
    bat: 56,
    utc: 1660116915,
    tel: {
      lb: 153.3,
      kg: 69.6,
      pul: 88.0,
      bmi: 24.1,
      mm: 27.5,
      res: 530.0,
      bw: 43.4,
      bfr: 18.4,
      bms: 2.0,
      bm: 1588.9,
      bf: 12.8,
      br: 2.9,
      ffm: 56.7,
      mr: 39.5,
      wr: 62.4,
    },
  },
  Glucometer: {
    devid: "F087334Z0572",
    model: "Zewa_glucometer",
    type: "Glucometer",
    hub_id: "hub_id",
    utc: 1660325845,
    bat: 0,
    tel: { gluc: 278.0, unit: "mg/dL", hilo: "-", meal: "-" },
  },
  Thermometer: {
    devid: "1893D70CE39A",
    model: "Zewa_temperature_11115",
    type: "Thermometer",
    hub_id: "hub_id",
    utc: 1659432959,
    bat: 0,
    tel: { tempc: 98.2, tempf: 36.78, tempm: "Head" },
  },
  bp_cellular: {
    model: "BPM",
    bat: 100,
    csq: 10,
    sim: "89011703278659511656",
    utc: "63242CC2",
    imei: "860623063230237",
    type: "Blood Pressure",
    zone: "GMT-4",
    tel: {
      dia: 76,
      ihb: 0,
      pul: 70,
      sys: 118,
      unum: 1,
    },
  },
  cellular_scale: {
    bat: 75,
    sig: 31,
    sim: "89011702278254784337",
    tel: { kg: 83.1, lb: 183.2 },
    utc: "0x63bffad4",
    imei: "867420042298507",
    type: "Scale",
    zone: "UTC+8",
    model: "Zewa Scale",
  },
  activity_tracker: {
    bat: "20",
    tel: {
      awa: "0",
      cal: "62",
      Lpul: "85",
      step: "2087",
      Lspo2: "0",
      Ltemp_C: "0",
      Maxpul: "85",
      Minpul: "77",
      dist_M: "1753",
      dsleep: "148",
      lsleep: "290",
      Lstress: "0.5",
      Ltemp_F: "32.0",
      Maxspo2: "0",
      Maxtemp_C: "0",
      Minspo2: "0",
      Mintemp_C: "0",
      dist_Mi: "1.09",
      Maxstress: "1",
      Maxtemp_F: "32.0",
      Minstress: "0.1",
      Mintemp_F: "32.0",
    },
    utc: 1673525205,
    type: "Fitness",
    devid: "11111",
    model: "Zewa 1221",
    hub_id: "NA",
  },
  cellular_glucometer: {
    bat: "90",
    sig: 4,
    sim: "89011703278794868862",
    tel: { gluc: 426, meal: 0, unit: 2, sample: 1, target: 1 },
    utc: "0x66627536",
    imei: "864351051283960",
    type: "Glucometer",
    zone: "UTC+8",
    model: "21540",
  },
};
